import styles from './Spinner.module.sass'

export default function Spinner() {
  return (
    <div className={styles.container}>
      <span className={styles.spinner}></span>
    </div>
  )
}
